import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  success: {
    defaultMessage: 'Success',
    id: 'ScenariosList.success',
  },
  error: {
    defaultMessage: 'Error',
    id: 'ScenariosList.error',
  },
  scenarioNumber: {
    defaultMessage: 'Scenario {number}',
    id: 'ScenariosList.scenarioNumber',
  },
  customScenario: {
    defaultMessage: 'Custom scenario',
    id: 'ScenariosList.customScenario',
  },
  allScenariosDescription: {
    defaultMessage: 'Test different scenarios and authentication methods.',
    id: 'ScenariosList.allScenariosDescription',
  },
  demoCredentialsRequired: {
    defaultMessage: 'Demo credentials required',
    id: 'ScenariosList.demoCredentialsRequired',
  },
  custom: {
    defaultMessage: 'Custom',
    id: 'ScenariosList.custom',
  },
  allScenarios: {
    defaultMessage: 'All scenarios',
    id: 'ScenariosList.allScenarios',
  },
  predeterminedScenarios: {
    defaultMessage: 'Predetermined scenarios',
    id: 'ScenariosList.predeterminedScenarios',
  },
});
